import { Box, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useEffect, useState } from 'react';
import { useScreenLargerThan } from '../../lib/hooks/breakpoint-hooks';
import { INVALID_DATE } from '../Utils/InternalDatePicker';
import moment from "moment";
import AuditDatePicker from "./AuditDatePicker";

export type InputDateProps = {
    startDate: string;
    endDate: string;
    // eslint-disable-next-line
    setStartDate: any;
    // eslint-disable-next-line
    setEndDate: any;
};

const FilterByDatePicker = ({ startDate, setStartDate, endDate, setEndDate }: InputDateProps) => {
    const isLargerThanSmall = useScreenLargerThan('sm');
    const [intervalError, setIntervalError] = useState(false);

    useEffect(() => {
        if (
            startDate.toString().toLowerCase() !== INVALID_DATE.toLowerCase() &&
            endDate.toString().toLowerCase() !== INVALID_DATE.toLowerCase()
        ) {
            const sDate = moment(startDate);
            const eDate = moment(endDate);

            //Compare by miliseconds passed from epoch
            setIntervalError(sDate.unix() > eDate.unix());
        }
    }, [startDate, endDate]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box
                sx={
                    isLargerThanSmall
                        ? { display: 'inline-flex' }
                        : { display: 'flex', justifyContent: 'space-between' }
                }>
                <Box
                    sx={
                        isLargerThanSmall
                            ? {
                                  display: 'flex',
                                  alignItems: 'center'
                              }
                            : { display: 'block' }
                    }>
                    <Typography sx={{ paddingRight: '12px' }}>Start Date</Typography>
                    <AuditDatePicker
                        sx={{ width: '150px' }}
                        min={''}
                        max={''}
                        dateValue={startDate}
                        intervalError={intervalError}
                        onDateChange={(v) => {
                            setStartDate(v, true);
                        }}
                    />
                </Box>
                <Box
                    sx={
                        isLargerThanSmall
                            ? {
                                  display: 'flex',
                                  alignItems: 'center'
                              }
                            : { display: 'block' }
                    }>
                    <Typography sx={{ padding: '0 12px' }}>End Date</Typography>
                    <AuditDatePicker
                        sx={{ width: '150px' }}
                        min={startDate}
                        max={''}
                        dateValue={endDate}
                        intervalError={intervalError}
                        onDateChange={(v) => {
                            setEndDate(v, true);
                        }}
                    />
                </Box>
            </Box>
        </LocalizationProvider>
    );
};

export default FilterByDatePicker;
